import React, { useEffect, useRef, useState } from "react";
import { Drawer, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getBookingListForNightAudit,
  getUnSettlledInvoiceListForNightAudit,
  resetPageNo,
  resetState,
  updateDisplayNightAuditDrawer,
  updateMultipleBookingForNightAudit,
} from "../../reducer/nightAuditReducer";
import { IoIosArrowRoundBack } from "react-icons/io";
import {
  formatNightAuditDate,
  nightAuditdDawerWidth,
  nightAuditTabEnum,
} from "../../utils/nightAuditHelper";
import Tab from "./Tab";
import Footer from "./Footer";
import Body from "./NightAuditMainSection";
import moment from "moment";
import { GET_ISO_FORMAT } from "../../utils/helper";
import { getNightAuditReport } from "../../reducer/reportReducer";
import TakePaymentDrawer from "./TakePaymentDrawer";
import AttachToPartyDrawer from "./AttachToPartyDrawer";
import usePrint from "../../hooks/usePrint";
import NightAuditConfirmationModal from "../appHeader/NightAuditConfirmationModal";

const NightAuditDrawer = () => {
  const dispatch = useDispatch();
  const { hotelDetails } = useSelector((store) => store.login);
  const {
    loading,
    apiError,
    response,
    displayNightAuditDrawer,
    infinateScroll,
    pageNumber,
    bulkUpdateLoading,
    dataChanged,
  } = useSelector((store) => store.nightAudit);

  const { nightAuditResponse, nightAuditLoading } = useSelector(
    (store) => store.report
  );

  const { currentNightAuditDate } = useSelector((store) => store.appHeader);

  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState([...response]);
  const [allSelected, setAllSelected] = useState(false);

  const summaryRef = useRef();

  const [selectedInvoice, setSelectedInvoice] = useState([]);

  useEffect(() => {
    if (!displayNightAuditDrawer) return;

    search();
  }, [displayNightAuditDrawer, activeTab, dataChanged]);

  useEffect(() => {
    if (infinateScroll) search();
  }, [pageNumber]);

  const handleClose = () => {
    dispatch(updateDisplayNightAuditDrawer(false));
    dispatch(resetState());
    setActiveTab(0);
  };

  const handleTabChange = (newValue) => {
    dispatch(resetState());
    setActiveTab(newValue);
    setSelectedInvoice([]);
    dispatch(resetPageNo());
  };

  const search = async () => {
    let zoneOffset = hotelDetails?.zoneOffset;

    // Custom Tize Zone
    const startOfDayWithOffset = moment(currentNightAuditDate)
      .startOf("day")
      .utcOffset(zoneOffset)
      .toISOString();

    const endOfDayWithOffset = moment(currentNightAuditDate)
      .endOf("day")
      .utcOffset(zoneOffset)
      .toISOString();

    if (activeTab === 0) {
      let payload = {
        statuses: "checkedIn",
        hotelId: hotelDetails?.id,
        pageNumber: pageNumber,
        checkOutEndDate: endOfDayWithOffset,
        pageSize: 20,
      };
      dispatch(getBookingListForNightAudit(payload));
    } else if (activeTab === 1) {
      let payload = {
        statuses: "confirmed",
        hotelId: hotelDetails?.id,
        pageNumber: pageNumber,
        pageSize: 20,
        checkInEndDate: endOfDayWithOffset,
      };

      dispatch(getBookingListForNightAudit(payload));
    } else if (activeTab === 2) {
      let payload = {
        hotelId: hotelDetails?.id,
        pageNumber: pageNumber,
        pageSize: 20,

        startDate: startOfDayWithOffset,
        endDate: endOfDayWithOffset,
      };

      dispatch(getUnSettlledInvoiceListForNightAudit(payload));
    } else {
      const payload = {
        hotelIds: hotelDetails?.id,
        startDate: GET_ISO_FORMAT(
          moment(currentNightAuditDate)
        ).slice(0, 10),
      };

      dispatch(getNightAuditReport(payload));
    }
  };

  const handlePendinReservationInBulk = async (status) => {
    if (selectedInvoice?.length <= 0) {
      message.destroy();
      message.info("Select atleast one Booking");
    }

    let selectedBooking = data
      ?.filter((Obj) => Obj?.isSelected)
      ?.map((Obj) => {
        return {
          ...Obj,
          status: status,
        };
      });

    if (!Array.isArray(selectedBooking) || selectedBooking?.length <= 0) {
      return;
    }

    dispatch(updateMultipleBookingForNightAudit(selectedBooking));
  };

  const { loading: printSummaryLoading, printFile: printSummary } = usePrint(
    summaryRef,
    "Invoice"
  );

  useEffect(() => {
    setData(response);
    setSelectedInvoice([]);
    setAllSelected(false);

    return () => {
      setData([]);
      setAllSelected(false);
    };
  }, [response]);

  return (
    <Drawer
      headerStyle={{ padding: 0, margin: 0 }}
      bodyStyle={{ padding: 0, margin: 0 }} // Remove padding and margin
      closeIcon={<></>}
      closable={false}
      onClose={handleClose}
      open={displayNightAuditDrawer}
      width={nightAuditdDawerWidth}
      title={
        <div className="bg-surface-page p-2 pl-4 border-b-[1px] border-brand-border-muted flex items-center gap-3 ">
          <IoIosArrowRoundBack
            className="text-[24px] text-neutral-800 cursor-pointer"
            onClick={handleClose}
          />
          <span className=" font-[500]  text-[14px] leading-[12px] tracking-wider text-black ">
            Night Audit - {formatNightAuditDate(currentNightAuditDate)}
          </span>
        </div>
      }
      mask={true}
    >
      <div className="w-[100%] h-[100%]">
        <Tab
          nightAuditTabEnum={nightAuditTabEnum}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />

        <Body
          activeTab={activeTab}
          loading={loading}
          apiError={apiError}
          infinateScroll={infinateScroll}
          data={data}
          setData={setData}
          allSelected={allSelected}
          setAllSelected={setAllSelected}
          selectedInvoice={selectedInvoice}
          setSelectedInvoice={setSelectedInvoice}
          nightAuditResponse={nightAuditResponse}
          nightAuditLoading={nightAuditLoading}
          hotelDetails={hotelDetails}
          summaryRef={summaryRef}
        />

        <Footer
          loading={loading}
          drawerWidth={nightAuditdDawerWidth}
          activeTab={activeTab}
          handlePendinReservationInBulk={handlePendinReservationInBulk}
          setActiveTab={setActiveTab}
          data={data}
          selectedInvoice={selectedInvoice}
          bulkUpdateLoading={bulkUpdateLoading}
          printSummary={printSummary}
        />
      </div>

      <TakePaymentDrawer selectedInvoice={selectedInvoice?.[0]} />
      <AttachToPartyDrawer selectedInvoice={selectedInvoice?.[0]} />
      <NightAuditConfirmationModal setActiveTab={setActiveTab} />
    </Drawer>
  );
};

export default NightAuditDrawer;
